import helper from '../../../helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('portaliGalleries');
export const actions = helper.createActions('portaliGalleries', actionTypes);
